/**
 * Push best-effort clients / events / products (UUID) vers Supabase — déclenché par debounce sur changements store.
 */
import { isSupabaseReady } from "./supabase";
import { upsertClient, upsertEvent, upsertProduct } from "./supabasePersistence";
import { clientAppToDbRow, eventAppToDbRow, productAppToDbRow } from "../utils/supabaseRowMappers";
import { logger } from "../utils/logger";

const MAX_EACH = 500;

export async function pushNormalizedEntitiesFromStore(get) {
  const coachId = get().coachId;
  if (!isSupabaseReady(coachId)) return;

  const s = get();
  const clients = !s.demoMode && s._realData ? s._realData.clients : s.clients;
  const events = !s.demoMode && s._realData ? s._realData.events : s.events;
  const products = s.products;

  let nClient = 0;
  for (const c of clients || []) {
    if (nClient >= MAX_EACH) break;
    const row = clientAppToDbRow(c, coachId);
    if (!row) continue;
    const { error } = await upsertClient(row);
    if (error) logger.warn("[pushEntities] client", { id: row.id, detail: error.message || error });
    else nClient++;
  }

  let nEv = 0;
  for (const e of events || []) {
    if (nEv >= MAX_EACH) break;
    const row = eventAppToDbRow(e, coachId);
    if (!row) continue;
    const { error } = await upsertEvent(row);
    if (error) logger.warn("[pushEntities] event", { id: row.id, detail: error.message || error });
    else nEv++;
  }

  let nPr = 0;
  for (const p of products || []) {
    if (nPr >= MAX_EACH) break;
    const row = productAppToDbRow(p, coachId);
    if (!row) continue;
    const { error } = await upsertProduct(row);
    if (error) logger.warn("[pushEntities] product", { id: row.id, detail: error.message || error });
    else nPr++;
  }
}
